// React libs
import { useState, useEffect, useContext } from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
// Services
import MapService from '../Services/MapService';
// Types
import * as CoreTypes from '../../../../Core/Data/Models/Core.type';
import * as MapTypes from '../Models/Map.type';
// Contexts
import UserContext, { IUserContext } from '../../../../Core/Data/Contexts/UserContext'
// Common
import CoreCommon from '../../../../Core/Resources/Common';

export interface IGetMapSharesHook extends CoreTypes.IHook<MapTypes.IMapShare[]> { }

const useMapShares = (): IGetMapSharesHook => {
  // Variables
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation(['common']);

  // Contexts
  const { user }: IUserContext = useContext(UserContext)

  // State
  const [data, setData] = useState<MapTypes.IMapShare[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Effects
  useEffect(() => {
    setIsLoading(true)
    MapService.getMapShares(user?.profile.person.account.id)
      .then((data: MapTypes.IData<MapTypes.IMapShare>) => {
        setData(data.data)
        setIsLoading(false)
      })
      .catch((e: CoreTypes.IWsException) => {
        enqueueSnackbar(
          e?.error?.message || t('common:errors.defaultMessage'),
          {
            ...CoreCommon.Constantes.snackbarDefaultProps,
            variant: 'error',
          }
        );
        setIsLoading(false);
      });
  }, [enqueueSnackbar, t, user])

  return { data, isLoading }
}

export default useMapShares